<div class="row">
  <div class="col">
    <div class="btn btn-primary" (click)="add()" style="cursor: pointer;">Add device</div>
  </div>
  <div class="col-md-1 text-end">
    <i class="fa-light fa-line-columns iconpointer" (click)="changeToList(true)"></i>&nbsp;&nbsp;&nbsp;<i
      class="fa-light fa-grid-2 iconpointer" (click)="changeToList(false)"></i>
  </div>
</div>

<!-- Listview -->
<table class="table" *ngIf="listView">
  <thead>
    <tr>
      <th scope="col">ID</th>
      <th scope="col">Description</th>
      <th scope="col">Department</th>
      <th scope="col" class="text-end"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of devices[0]">
      <td>{{item.mac_address}}</td>
      <td>{{item.description}}</td>
      <td>{{item.department_name}}</td>
      <td class="text-end">
        <div class="btn btn-primary" (click)="edit(item.id)" style="cursor: pointer;">Edit</div>&nbsp;
        <div class="btn btn-primary" (click)="assign(item.id)" style="cursor: pointer;">Assign scenario</div>
      </td>
    </tr>
  </tbody>
</table>

<!-- Cards -->
<div *ngIf="!listView" class="tiles">
  <div class="card-columns">
    <div class="container">
      <div class="row gy-3">
        <div class="col-sm-3" *ngFor="let item of devices[0]">
          <div class="card h-100">
            <div class="row" style="margin:5px;">
              <div class="col" style="padding:15px;">
                <h5>{{item.description}}</h5>
              </div>
              <div class="col text-end"><img src="/assets/img/screen.jpg" class="card-img-top"></div>
            </div>
            <div class="card-body">
              <p class="card-text">
                <i class="fa-light fa-ethernet"></i>&nbsp;&nbsp;{{item.mac_address}}
              </p>
              <p>
                <i class="fa-light fa-building-user"></i>&nbsp;&nbsp;{{item.department_name}}
              </p>
            </div>
            <div class="card-footer bg-transparent border-success">
              <div class="btn btn-link" (click)="edit(item.id)" style="cursor: pointer;">Edit</div>&nbsp;
              <div class="btn btn-link" (click)="assign(item.id)" style="cursor: pointer;">Assign scenario</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>